import { Dialog, Grid } from "@mui/material";
import { DialogHeader } from "../../../auth/components/PasswordRecoveryModal";
import { ClientInfo } from "../pages/ClientDetails";
import { Collaborator } from "../types";
import { useEffect, useState } from "react";
import { usersApi, usinasApi } from "../../../services/api";
import { UsinaByClient } from "../../usinas/types";
import { ItemsDetails } from "../../../main/components/ItemsDetails";
import { AddItemModals } from "../../users/components/AddItemModals";
import { Item } from "../../users/components/UserItemsTable";
import { RemoveUsinaModals } from "../../users/components/RemoveUsinaModals";
import { RemoveRoleModals } from "../../users/components/RemoveRoleModals";
import { UserRoles } from "../../users/types";

type CollaboratorDetailsModalProps = {
  showDetailsModal: boolean;
  setShowDetailsModal: (value: boolean) => void;
  item: Collaborator;
  clientId: string;
  update: () => void;
};

export default function CollaboratorDetailsModal(
  props: CollaboratorDetailsModalProps
) {
  const [usinas, setUsinas] = useState<UsinaByClient[]>([]);
  const [showAddUsinaModal, setShowAddUsinaModal] = useState<boolean>(false);
  const [selectedUsina, setSelectedUsina] = useState<Item | null>(null);
  const [showRemoveUsinaModal, setShowRemoveUsinaModal] =
    useState<boolean>(false);
  const [showAddRoleModal, setShowAddRoleModal] = useState<boolean>(false);
  const [allRoles, setAllRoles] = useState<Item[]>([]);
  const [selectedRole, setSelectedRole] = useState<Item | null>(null);
  const [showRemoveRoleModal, setShowRemoveRoleModal] =
    useState<boolean>(false);

  const onClose = () => {
    props.setShowDetailsModal(false);
  };
  const update = () => {
    props.update();
    onClose();
  };

  const onMount = async () => {
    try {
      const usinasResponse = await usinasApi.getUsinasByClientId(
        props.clientId
      );
      setUsinas(usinasResponse.data);
      const rolesResponse = await usersApi.getAllRoles();
      setAllRoles(rolesResponse);
    } catch (error) {
      throw new Error("Erro ao carregar usinas");
    }
  };

  useEffect(() => {
    onMount();
  }, [props.clientId]);

  const collaboratorUsinas =
    usinas
      .filter((u) => props.item.usinasIds?.includes(u.usinaIds.id))
      .map((e) => {
        return {
          id: e.usinaIds.id || "",
          name: e.name || "",
        };
      }) || [];

  const onConfirmAddUsina = async (item: Item) => {
    await usersApi.addUsina(
      props.item.email ?? "",
      props.clientId,
      item.id ?? ""
    );
  };
  const onRemoveUsina = async (item: Item) => {
    setSelectedUsina(item);
    setShowRemoveUsinaModal(true);
  };
  const onConfirmRemoveUsina = async () => {
    if (!selectedUsina || !props.clientId) return;
    await usersApi.removeUsina(
      props.item.email ?? "",
      props.clientId,
      selectedUsina.id ?? ""
    );
  };

  const userRoles =
    props.item?.roles
      ?.map((role) => ({
        id: role,
        name: role,
        cantRemove: role === UserRoles.User || role === UserRoles.Client,
      }))
      .filter((role) => allRoles.map((r) => r.name).includes(role.name)) || [];

  const roles = allRoles
    .filter((role) => !userRoles.map((r) => r.name).includes(role.name ?? ""))
    .map((role) => {
      return {
        id: role.name ?? "",
        name: role.name,
      };
    });

  const onConfirmAddRole = async (item: Item) => {
    await usersApi.addRole(
      props.item.email ?? "",
      props.clientId,
      item.id ?? ""
    );
  };

  const onRemoveRole = async (item: Item) => {
    if (item.name === UserRoles.User || item.name === UserRoles.Client) {
      return;
    }
    setSelectedRole(item);
    setShowRemoveRoleModal(true);
  };

  const onConfirmRemoveRole = async () => {
    if (!selectedRole) return;
    await usersApi.removeRole(
      props.item.email ?? "",
      props.clientId ?? "",
      selectedRole.id ?? ""
    );
  };

  return (
    <>
      <Dialog open={props.showDetailsModal} onClose={onClose}>
        <DialogHeader id="customized-dialog-title" onClose={onClose}>
          {`Detalhe do Colaborador`}
        </DialogHeader>
        <Grid
          padding={{
            xs: "5px",
            sm: "10px",
          }}
        >
          <Grid item xs={12} paddingBottom={"10px"} display={"flex"}>
            <ClientInfo
              paddingLeft
              valueWidth={"150px"}
              title="Nome"
              value={props.item.name}
            />
          </Grid>
          <Grid item xs={12} paddingBottom={"10px"} display={"flex"}>
            <ClientInfo
              paddingLeft
              valueWidth={"150px"}
              title="Email"
              value={props.item.email}
            />
          </Grid>
          <Grid item xs={12} paddingBottom={"10px"} display={"flex"}>
            <ClientInfo
              paddingLeft
              valueWidth={"150px"}
              title="CPF"
              value={props.item.cpf}
            />
          </Grid>
          <Grid item xs={12} paddingBottom={"10px"} display={"flex"}>
            <ClientInfo
              paddingLeft
              valueWidth={"150px"}
              title="Telefone"
              value={props.item.phone}
            />
          </Grid>
          <Grid item display={"flex"} xs={12}>
            <ItemsDetails
              items={collaboratorUsinas}
              label="Usinas"
              itemLabel="usina"
              onAdd={() => {
                setShowAddUsinaModal(true);
              }}
              style={{
                display: "flex",
                alignItems:
                  collaboratorUsinas.length > 0 ? "flex-start" : "center",
                height: "100%",
              }}
              onRemove={onRemoveUsina}
            />
          </Grid>
          <Grid item xs={12} textAlign={"start"}>
            <ItemsDetails
              items={userRoles}
              label="Perfis"
              itemLabel="perfil"
              onAdd={() => {
                setShowAddRoleModal(true);
              }}
              style={{
                display: "flex",
                alignItems: userRoles.length > 0 ? "flex-start" : "center",
                height: "100%",
              }}
              onRemove={onRemoveRole}
            />
          </Grid>
          {/* <Grid item xs={12} paddingBottom={"10px"} display={"flex"}>
            <RopTable itemRows={tableRows} />
          </Grid> */}
        </Grid>
      </Dialog>
      <AddItemModals
        itemName="Usina"
        itemText="a usina"
        items={usinas
          .filter(
            (usina) =>
              !collaboratorUsinas.map((u) => u.id).includes(usina.usinaIds.id)
          )
          .map((usina) => {
            return {
              id: usina.usinaIds.id,
              name: usina.name,
            };
          })}
        onConfirmAddItem={onConfirmAddUsina}
        setShowAddItemModal={setShowAddUsinaModal}
        showAddItemModal={showAddUsinaModal}
        onMount={update}
      />
      <RemoveUsinaModals
        onConfirmRemoveUsina={onConfirmRemoveUsina}
        showRemoveUsinaModal={showRemoveUsinaModal}
        setShowRemoveUsinaModal={setShowRemoveUsinaModal}
        usinaName={selectedUsina?.name || ""}
        onMount={update}
      />
      <AddItemModals
        itemName="Perfil"
        itemText="o perfil"
        items={roles}
        onConfirmAddItem={onConfirmAddRole}
        setShowAddItemModal={setShowAddRoleModal}
        showAddItemModal={showAddRoleModal}
        onMount={update}
      />
      <RemoveRoleModals
        onConfirmRemoveRole={onConfirmRemoveRole}
        showRemoveRoleModal={showRemoveRoleModal}
        setShowRemoveRoleModal={setShowRemoveRoleModal}
        roleName={selectedRole?.name || ""}
        onMount={update}
      />
    </>
  );
}
